import { FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import { TimePicker, TimePickerProps } from '@givebutter/primitives/date-time-picker';
import { get } from 'lodash';

interface UseFormTimePickerProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseControllerProps<T, K>,
        Omit<TimePickerProps, 'name'> {}

const UseFormTimePicker = <T extends FieldValues, K extends FieldPath<T>>(
    props: UseFormTimePickerProps<T, K>,
) => {
    const { control, name, defaultValue, rules, onValueChange: onSelectConsumer, ...rest } = props;
    const {
        field: { value, onChange: onChangeInternal, ...restFormProps },
        formState: { errors },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
    });

    const error = get(errors, name);

    const onChange: TimePickerProps['onValueChange'] = value => {
        onChangeInternal(value);
        onSelectConsumer?.(value);
    };

    return (
        <TimePicker
            {...restFormProps}
            {...rest}
            error={Boolean(error?.message)}
            value={value}
            onValueChange={onChange}
        />
    );
};

export { UseFormTimePicker };
export type { UseFormTimePickerProps };
